<div class="content-header">
  <div class="container-fluid">
    <div class="headingTop">
      <div class="row mb-2 align-items-center">
        <div class="col-sm-6 headingCol">
          <h1 class="m-0 text-dark">Dashboard </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-6 headingCol">
          <!-- <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                    <li class="breadcrumb-item active">Dashboard v1</li>
                </ol> -->
        </div>
        <!-- /.col -->
      </div>
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <!-- Small boxes (Stat box) -->
    <div class="row">
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box3 text-center"><img src="assets/img/Total_Users.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>{{dashStatistics?.total_users || 0}}</h5>
                <p>Total Users</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box4 text-center"><img src="assets/img/Total_Approvals.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>{{dashStatistics?.total_approved_users || 0}}</h5>
                <p>Total Approval</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->

      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box1 text-center"><img src="assets/img/Total_Pilots.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>{{dashStatistics?.total_pilot_users || 0}}</h5>
                <p>Total Pilots</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box2 text-center"><img src="assets/img/Total_Owners.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>{{dashStatistics?.total_owner_users || 0}}</h5>
                <p>Total Owners </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box3 text-center"><img src="assets/img/Admin_Payouts.svg"></div>
              </div>
              <div class="col-9 icon-content">
               <h5>${{ dashStatistics?.total_admin_payouts || 0 | number:'1.0-0' }}</h5>
                <p>Admin Payouts</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box4 text-center"><img src="assets/img/Pilot_Payouts.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>${{ dashStatistics?.total_pilot_payments || 0 | number:'1.0-0' }}</h5>
                <p>Total Pilot Payments</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->

      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box1 text-center"><img src="assets/img/Owner_Payouts.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>${{ dashStatistics?.total_owner_payments || 0 | number:'1.0-0' }}</h5>
                <p>Total Owner Payments</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./col -->
      <div class="col-xl-3 col-6 dashTopCol">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="cardcont">
            <div class="icnBlock row">
              <div class="col-3 pr-0">
                <div class="icnBox icon-box2 text-center"><img src="assets/img/Support_Tickets.svg"></div>
              </div>
              <div class="col-9 icon-content">
                <h5>{{ dashStatistics?.total_support_tickets || 0 }}</h5>
                <p>Total Support Tickets</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="dashMidDv1">
    <div class="row equal-height-row">
      <div class="col-lg-6 col-md-6">
          <div class="card pay ">
            <div class="card-title text-center card-title"> New Pilot Trend</div>
            <div class="">
              <div class="row">
                <!-- <div *ngIf="ChartDataPilot"> -->
                  <app-line-chart [chartData]="ChartDataPilot" [chartName]="'Number of Pilots'"
                  [chartTitleName]="'New Pilot'">
                  </app-line-chart>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="card pay ">
            <div class="card-title text-center card-title"> New Owner Trend</div>
            <div class="">
              <div class="row">
                <!-- <div class="col-md-12 text-center"> -->
                  <app-line-chart  [chartData]="ChartDataOwner" [chartName]="'Number of Owners'"
                  [chartTitleName]="'New Owner'">
                  </app-line-chart>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="card pay ">
            <div class="card-title text-center card-title"> New Subscription Trend </div>
            <div class="">
              <div class="row">
                <!-- <div class="col-md-12 text-center"> -->
                  <app-line-chart [chartData]="ChartData2" [chartName]="'Number of Subscriptions'"
                  [chartTitleName]="'New Subscription'">
                  </app-line-chart>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="card pay ">
            <div class="card-title text-center card-title"> Unsubscription Trend </div>
            <div class="">
              <div class="row">
                <!-- <div class="col-md-12 text-center"> -->
                  <app-line-chart [chartData]="ChartData2" [chartName]="'Number of Unsubscriptions'"
                  [chartTitleName]="'Unsubscription Trend'">
                  </app-line-chart>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
